import { useEffect, useState } from "react";
import { Copy, RefreshCw, Eye, EyeOff, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Spinner, Card } from "@/components/dash";
import { Button } from "@/components/ui/button";
import api, { apiErr } from "@/lib/api";

export default function ApiKeys() {
  const [keys, setKeys] = useState(null);
  const [show, setShow] = useState(false);

  const load = () => api.get("/apikeys").then(({ data }) => setKeys(data)).catch(() => setKeys({}));
  useEffect(() => { load(); }, []);

  const copy = (v) => { navigator.clipboard.writeText(v); toast.success("Kopyalandı."); };
  const rotate = async () => {
    try { const { data } = await api.post("/apikeys/rotate"); setKeys(data); toast.success("Anahtarlar yenilendi."); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (!keys) return <Spinner />;

  return (
    <div>
      <PageHeader title="API Anahtarları" desc="Coinbuy API'sine erişmek için anahtarlarınız."
        action={<Button variant="outline" onClick={rotate} data-testid="rotate-keys-btn" className="rounded-full"><RefreshCw size={15} /> Yenile</Button>}
      />
      <div className="space-y-4">
        <Card className="p-6">
          <div className="flex items-center gap-2 text-sm font-semibold"><KeyRound size={16} className="text-primary" /> Publishable Key</div>
          <p className="text-xs text-muted-foreground mt-1">İstemci tarafında kullanılabilir.</p>
          <div className="mt-3 flex gap-2">
            <code className="flex-1 rounded-lg border border-border bg-muted px-3 py-2.5 text-xs font-mono truncate" data-testid="publishable-key">{keys.publishable_key}</code>
            <Button variant="outline" size="icon" onClick={() => copy(keys.publishable_key)}><Copy size={15} /></Button>
          </div>
        </Card>
        <Card className="p-6">
          <div className="flex items-center gap-2 text-sm font-semibold"><KeyRound size={16} className="text-red-500" /> Secret Key</div>
          <p className="text-xs text-muted-foreground mt-1">Gizli tutun. Yalnızca sunucu tarafında kullanın, asla paylaşmayın.</p>
          <div className="mt-3 flex gap-2">
            <code className="flex-1 rounded-lg border border-border bg-muted px-3 py-2.5 text-xs font-mono truncate" data-testid="secret-key">{show ? keys.secret_key : "sk_live_" + "•".repeat(24)}</code>
            <Button variant="outline" size="icon" onClick={() => setShow((v) => !v)}>{show ? <EyeOff size={15} /> : <Eye size={15} />}</Button>
            <Button variant="outline" size="icon" onClick={() => copy(keys.secret_key)}><Copy size={15} /></Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
